// extracted by mini-css-extract-plugin
export default {"loading-wrapper":"Loading_loading-wrapper__4oqhA","lds-ring":"Loading_lds-ring__c3qUP"};